import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { ViewState } from './view.interfaces';

@Injectable()
export class ViewSelectors {
  public view$: Observable<ViewState>;

  constructor(
    private store: Store<any>
  ) {
    this.view$ = this.store.select(state => state.view);
  }

  getModal() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.modal)
      .distinctUntilChanged());
  }

  getModalImage() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.modalImage)
      .distinctUntilChanged());
  }

  getAlerts() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.alerts)
      .distinctUntilChanged());
  }

  getViewInFullscreen() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.fullscreen)
      .distinctUntilChanged());
  }

  getViewLoading() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.loading)
      .distinctUntilChanged());
  }

  isAudioExtPlaying() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.audioExtPlaying)
      .distinctUntilChanged());
  }

  isAudioExtPlayingAccepted() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.audioExtPlayingAccepted)
      .distinctUntilChanged());
  }

  getIsModalVisible() {
    return this.getModal()
      .map(modal => modal.active);
  }

  getIsModalImageVisible() {
    return this.getModalImage()
      .map(modal => modal.active);
  }

  getIsModalLoading() {
    return this.getModal()
      .map(modal => modal.loading);
  }

  getViewName() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.name)
      .distinctUntilChanged());
  }

  getAudio() {
    return this.view$
      .let((state$: Observable<ViewState>) => state$
      .map(state => state.audio)
      .distinctUntilChanged());
  }
}



// WEBPACK FOOTER //
// ./src/app/logics/view/view.selectors.ts